import React, { useState, useContext } from 'react'
import firebase from '../../utils/firebase'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import { DatePicker } from '@material-ui/pickers'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'

import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import _appContext from '../../contexts/appContext'
import _firebaseContext from '../../contexts/firebaseContext'

export default function PromocodeSetingsDialog({
    open,
    handleClose,
    promocode,
}) {
    const [promocodeId, setPromocodeId] = useState(promocode.id)
    const [performingAction, setPerformingAction] = useState(true)
    const [promocodeName, setPromocodeName] = useState(promocode.data.promocode)
    const [isActive, setIsActive] = useState(promocode.data.isActive)
    const [subscription, setSubscription] = useState(
        promocode.data.subscription
    )
    const [promocodeActivationCount, setPromocodeActivationCount] = useState(
        promocode.data.promocodeActivationCount
    )
    const [
        promocodeActivationMaxCount,
        setPromocodeActivationMaxCount,
    ] = useState(promocode.data.promocodeActivationMaxCount)
    const [expiryTime, setExpiryTime] = useState(promocode.data.expiryTime)

    const [errors, setErrors] = useState({
        email: false,
    })

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    const handlePromocodeNameChange = (event) => {
        setPromocodeName(event.target.value)
    }
    const handleIsActiveChange = (event) => {
        setIsActive(Boolean(event.target.checked))
    }
    const handleSubscriptionChange = (event) => {
        setSubscription(event.target.value)
    }
    const handlePromocodeActivationMaxCountChange = (event) => {
        setPromocodeActivationMaxCount(Number(event.target.value))
    }
    const handleExpiryTimeChange = (date) => {
        setExpiryTime(firebase.firestore.Timestamp.fromDate(date['$d']))
    }

    const handleSave = async (event) => {
        const updatedPromocode = {
            isActive: isActive,
            expiryTime: expiryTime,
            promocodeActivationMaxCount: promocodeActivationMaxCount,
            subscription: subscription,
        }
        let result = await firebaseContext.updatePromocode(
            promocodeId,
            updatedPromocode
        )
        appContext.snackbar.showSnackbarMsg(result.message)
        if (!result.errors) handleClose()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">
                Настройки промокода
            </DialogTitle>
            <DialogContent>
                <List>
                    <ListItem>
                        <TextField
                            autoFocus
                            disabled={!performingAction || promocodeName !== ''}
                            // error={!!(errors && errors.firstName)}
                            fullWidth
                            label="Промокод"
                            required
                            type="text"
                            value={promocodeName}
                            onChange={handlePromocodeNameChange}
                        />
                    </ListItem>
                    <ListItem>
                        <FormControlLabel
                            label="Активность"
                            control={
                                <Checkbox
                                    disabled={!performingAction}
                                    // error={!!(errors && errors.firstName)}
                                    checked={isActive}
                                    onChange={handleIsActiveChange}
                                    title="Активность"
                                />
                            }
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            disabled={!performingAction}
                            // error={!!(errors && errors.firstName)}
                            fullWidth
                            label="Количество активаций"
                            required
                            type="number"
                            value={promocodeActivationMaxCount}
                            onChange={handlePromocodeActivationMaxCountChange}
                        />
                    </ListItem>
                    <ListItem>
                        <InputLabel id="subscription-select-label">
                            Вид подписки
                        </InputLabel>
                        <Select
                            fullWidth
                            labelId="subscription-select-label"
                            value={subscription}
                            onChange={handleSubscriptionChange}
                            disabled={true}
                        >
                            <MenuItem value={'vip'}>VIP</MenuItem>
                            <MenuItem value={'regular'}>Regular</MenuItem>
                        </Select>
                    </ListItem>
                    <ListItem>
                        <InputLabel>Дата окончания действия</InputLabel>
                        <DatePicker
                            disabled={!performingAction}
                            // error={!!(errors && errors.firstName)}
                            fullWidth
                            ampm={false}
                            value={expiryTime && expiryTime.toDate()}
                            onChange={handleExpiryTimeChange}
                            format="DD MMMM YYYY"
                            cancelLabel="Отмена"
                            okLabel="Сохранить"
                            invalidDateMessage="Некорректная дата"
                            minDateMessage="Недопустимое значение"
                            maxDateMessage="Недопустимое значение"
                        />
                    </ListItem>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Отмена
                </Button>
                <Button onClick={handleSave} color="primary">
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    )
}
